export default __webpack_public_path__ + "static/media/Quick_Tag.6ac71a22.svg";